module.exports = __webpack_public_path__ + "static/media/71I2mUnn0AL._SL1500_.3d1efdc6.jpg";